import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const PcGender = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage,returnImage }) => {
  return (
    <div className="gender-pc" data-model-id="16859:591">

      <div className="contents">
        <div className="title">

          <div className="heading">What's your gender?</div>
        </div>

        <div className="div">
          <div className="sex-options">
            <div className="div-2">
              <Image onClick={() => {clickNext("female")}}
                  className="female-image"
                  alt="Beautiful shadows"
                  src={returnImage(true)} />

              <div className="text-wrapper">Female</div>
            </div>

            <div className="div-2">
              <Image onClick={() => {clickNext("male")}}
                  className="male-image"
                  alt="Beautiful shadows"
                  src={returnImage(false)} />

              <div className="text-wrapper">Male</div>
            </div>
          </div>

          <button className="button-2" onClick={() => {clickNext("female")}}>
            <Image src="/static/image/questionnaire/weight-loss/gender/pc/icon-nonbinary.png" alt="Icon nonbinary" className="icon-nonbinary" />

            <div className="non-binary-text">Non-binary</div>
          </button>
        </div>
      </div>
    </div>
  );
};
